export const SEARCH_PARAMS = {
	CUPON_CODE: 'cupon_code',
	YEAR: 'year',
};
